import { getPromoList, getSchoolAnalysisParams } from 'src/api/Admin'

export interface PromoListData{
    event_id: number,
    school_id: number,
    school_name: string,
    school_type_display: string,
    wide_loc: string,
    city_loc: string,
    visit_date: string,
    total_cnt: number,
    attendee_cnt: number,
    interested_cnt: number,
    apply_cnt: number,
    commissioned_count: number,
    not_interested_count: number
}

export const LoadPromoList = async (params:getSchoolAnalysisParams)=>{
    const response = await getPromoList(params)
    
    return {
        data: response.data as PromoListData[],
        totalPage: response.total_pages,
    };
}